import styled from 'styled-components'
import { OUTLINE_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_LG } from '@CSSVars/variables'


export const _MapControl = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 36px;
  right: 12px;
  z-index: 1001;
  border-radius: 10px;
  svg {
    fill: black;
  }
  button {
    width: 44px;
    height: 37px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-bottom: 1px solid ${OUTLINE_COLOR};
    &:hover {
      cursor: pointer;
    }
    ${({ onlyZoomBtns }) => (onlyZoomBtns ? `
        &:first-child {
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }
        &:last-child {
          border-bottom-right-radius: 10px;
          border-bottom-left-radius: 10px;
        }
    ` : `
    &:nth-child(2) {
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
    }

    &:last-child {
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    `)}

  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    bottom: 26px;
    right: 16px;
    box-shadow: none;
  }
`

export const _IconBox = styled.button`
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none !important;
  }
`
